export enum ScanStatus {
  Canceled = 'canceled',
  Complete = 'complete',
  Failed = 'failed',
  WaitingForData = 'waiting for data'
}
